import * as api from 'syft-acp-core/api/resources/admin/clientApplications'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('ADMIN_CLIENT_APPLICATIONS_FETCH', api.fetchAdminClientApplications)
}
